import { DbFile } from "../../core/DbFile";
import { DumbAttachment } from "./dumb-news-attachment";

export class PendingNewsInfo {
    articleTitle: string;
    articleContent: string;
    memberName: string;
    memberCompany: string;
    postingAs: string;
    previousSubmissions: number;
    lastSubmissionDate: Date;
    approverNotes: string;
    mainImageId: string;
    mainImageUrl: string;
    attachmentInfo: DumbAttachment[];
    newsId: number;
    isClosed: boolean;
    status: string;
    reviewerNotes: string;
}